export type DateFormat =
  | "YYYY-MM-DD"
  | "YYYY-MM-DDTHH:mm:ss"
  | "MONTH_LONG_PL"
  | "YYYY-MM-DD HH:mm"
  | "MM-YYYY"

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/


const toDate = (value: Date | string | number): Date => {
  if (value instanceof Date) {
    return value
  }

  if (typeof value === "string") {
    const dateOnly = DATE_ONLY_RE.exec(value.trim())
    if (dateOnly) {
      return new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    }
  }

  return new Date(value)
}

/**
 * Format date using a simple pattern like "YYYY-MM-DD" or "DD.MM.YYYY"
 * @param value Date or value convertible to Date
 * @param format Date format pattern (default: "YYYY-MM-DD")
 */
export function formatDate(
  value: Date | string | number,
  format: DateFormat = "YYYY-MM-DD"
): string {
  // Create Date instance
  const date = toDate(value);

  // Validate date
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date input");
  }

  if (format === "MONTH_LONG_PL") {
    return new Intl.DateTimeFormat("pl-PL", {
      month: "long",
    }).format(date);
  }

  // Extract date components
  const map: Record<string, string> = {
    YYYY: String(date.getFullYear()),
    MM: String(date.getMonth() + 1).padStart(2, "0"),
    DD: String(date.getDate()).padStart(2, "0"),
    HH: String(date.getHours()).padStart(2, "0"),
    mm: String(date.getMinutes()).padStart(2, "0"),
    ss: String(date.getSeconds()).padStart(2, "0"),
  };

  // Replace tokens in pattern
  let result : string = format;
  for (const token in map) {
    result = result.replace(token, map[token]);
  }

  return result;
}
